export default __webpack_public_path__ + "static/media/img1.3b5e1fd7.jpg";